import React from 'react';

import { QuoteCardWithScoreImprovements } from '@marketing/components/testimonial_card';

import KaraHeadshot from './assets/kara_headshot.png';
import RhiaHeadshot from './assets/rhia_headshot.png';

export default (props) => {
  return (
    <div className="d-flex flex-column flex-lg-row gap-m">
      <QuoteCardWithScoreImprovements
        scores={[
          { name: 'SAT Score', score: 1540, scoreIncrease: '+70 Point Increase' }
        ]}
        studentAvatar={RhiaHeadshot}
        studentName="Rhia"
      >
        Magoosh helped me understand the material better and prepared me well for the actual SAT by giving me practice with more complex problems. On the actual test day I was confident and well prepared!
      </QuoteCardWithScoreImprovements>

      <QuoteCardWithScoreImprovements
        scores={[
          { name: 'SAT Score', score: 1340, scoreIncrease: '+110 Point Increase' }
        ]}
        studentAvatar={KaraHeadshot}
        studentName="Kara"
      >
        Magoosh helped me in my weaknesses and even improved my strengths. With the videos, quizzes and estimated score values I was able to increase my understanding in all SAT subjects.
      </QuoteCardWithScoreImprovements>
    </div>
  );
};
